var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24File(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 3.375H13.2969C13.562 3.37508 13.8164 3.4805 14.0039 3.66797L18.832 8.49609C19.0195 8.68356 19.1249 8.93802 19.125 9.20312V19.625C19.125 20.1773 18.6773 20.625 18.125 20.625H5.875C5.32272 20.625 4.875 20.1773 4.875 19.625V4.375C4.875 3.85732 5.26833 3.43121 5.77246 3.37988L5.875 3.375Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.17017V8.375C13.125 8.92728 13.5727 9.375 14.125 9.375H19.3298",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24File);
export default __webpack_public_path__ + "static/media/24_file.0240000cef9128453115be9aafad1885.svg";
export { ForwardRef as ReactComponent };